import { render } from "./StaffSection.vue?vue&type=template&id=755cc9b6&ts=true"
import script from "./StaffSection.vue?vue&type=script&lang=ts"
export * from "./StaffSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__